import { useMemo } from "react";
import { CroppingSuitabilityReportModel } from "@agroyaar/sdk";
import { calculateAverage } from "@/helpers/chartHelper";
import ColumnChart from "@/shared/components/charts/ColumnChart";
import Title from "@/shared/components/report-template/presentation/components/common/Title";
import NoteBox from "@/shared/components/report-template/presentation/components/common/NoteBox";
import ReportTemplate from "@/shared/components/report-template/presentation/components/ReportTemplate";

interface AveragesGddProps {
  croppingSuitabilityReports: CroppingSuitabilityReportModel[];
  chartYears: string[];
}

const AveragesGdd = ({
  croppingSuitabilityReports,
  chartYears,
}: AveragesGddProps) => {
  const noteText = `براساس نمودار بالا، برای محصول ${
    croppingSuitabilityReports[0]?.crop?.persianName
  } ، میانگین واحد دمایی تامین شده در 30 سال گذشته 
   ${Math.round(
     calculateAverage(
       croppingSuitabilityReports[0]?.annuallySuppliedGrowingDegreeDay?.map(
         (annual) => annual.value
       )
     )
   )}
    درجه بوده است. درحالیکه مقدار واحد دمایی مورد نیاز برای این محصول ${
      croppingSuitabilityReports[0]?.growingDegreeDayRequirement
    } درجه است.`;

  const chartData = useMemo(
    () =>
      chartYears?.map((year, index) => ({
        name: year,
        value:
          croppingSuitabilityReports[0]?.annuallySuppliedGrowingDegreeDay[index]
            ?.value,
      })),
    [chartYears, croppingSuitabilityReports]
  );

  return (
    <ReportTemplate serviceType="CROPPING_SUITABILITY" pageNumber={6}>
      <div className="w-full flex flex-col justify-between gap-3">
        <div className="w-full flex flex-col gap-2">
          <Title>درجه روز رشد تامین شده سالانه (GDD)</Title>
          <div className="w-full flex flex-col justify-center items-center gap-2 my-5">
            <ColumnChart
              data={chartData}
              height={350}
              titleFontSize="12px"
              color="#4682B4"
              labelsFontSize="10px"
              yAxisTitle={"درجه روز رشد (GDD)"}
              plotLines={[
                {
                  value:
                    croppingSuitabilityReports[0]?.growingDegreeDayRequirement,
                  width: 4,
                  color: "orange",
                  zIndex: 9999,
                },
              ]}
            />
            <Title>
              مقدار واحد دمایی محاسبه شده برای طول فصل در طی 30 سال گذشته
            </Title>
          </div>
        </div>
        <div className="w-full flex flex-col gap-2 mt-8">
          <NoteBox>{noteText}</NoteBox>
        </div>
      </div>
    </ReportTemplate>
  );
};

export default AveragesGdd;
